export const obavijest_nemogucnost= {
    templateId: 70,
    category: 7,
    templateTitle: 'Izjava o zapljeni po pristanku dužnika - obavijest radnikovom vjerovniku (ovrhovoditelju) o nemogućnosti postupanja ',
    templateDescription: `<p>U slučaju da vjerovnik - ovrhovoditelj dostavi poslodavcu privatnu ispravu s učinkom pravomoćnog rješenju o ovrsi, poslodavac je dužan postupati po istoj sukladno Ovršnom zakonu, a u slučaju da ne može iz nekog razloga postupiti, predlaže se o tome obavijestiti ovrhovoditelja.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Dužnik (radnik) može privatnom ispravom potvrđenom kod javnog bilježnika dati suglasnost da se radi naplate tražbine vjerovnika zaplijeni njegova plaća, odnosno drugo stalno novčano primanje (suglasnost o zapljeni plaće), osim u dijelu u kojem je to primanje izuzeto od ovrhe.</p>
    <p>Isprava se izdaje u jednom primjerku te ima pravni učinak pravomoćnog rješenja o ovrsi. Ispravu s učincima dostave rješenja o ovrsi poslodavcu dostavlja vjerovnik, putem davatelja poštanskih usluga preporučenom poštanskom pošiljkom s povratnicom ili preko javnog bilježnika. Ne dostavi li se spomenuta isprava na opisani način, dostava ne proizvodi učinke dostave rješenja o ovrsi.</p>
    <p>Poslodavac radnika, na temelju te isprave dužan je zaplijenjeni dio plaće isplatiti, odnosno isplaćivati ovrhovoditelju po isteku roka od šezdeset dana od dana njezina primitka.</p>
    <p>Ako poslodavac propusti postupiti po suglasnosti za zapljenu plaće (privatnoj ispravi), ovrhovoditelj bi mogao samo u parničnom postupku potraživati naknadu štete od poslodavca zbog neizvršavanja svojih obveza.</p>
    <p>Ukoliko pak poslodavac ne može postupiti po dostavljenoj privatnoj ispravi uslijed ranijih obustava čiji iznos bi bio viši od najviše dopuštenog iznosa iz čl. 173. Ovršnog zakona, prijedlog je da se o tome obavijesti vjerovnika prema primjeru u nastavku.</p>
    <p>¸Kod prestanka radnog odnosa navedenog radnika, poslodavac ima sljedeće obveze:</p>
    <li> ukoliko mu je poznat novi poslodavac - bez odgode, preporučenom pošiljkom s povratnicom privatnu ispravu dostaviti novom poslodavcu prema primjeru <a class="local-link" href="/contract?template=73">ovdje</a>. Dodatni prijedlog je da se o navedenoj dostavi obavijesti i vjerovnik prema primjeru <a class="local-link" href="/contract?template=73.1">ovdje</a>.</p></li>
    <li> ukoliko mu nije poznat novi poslodavac - bez odgode, preporučenom pošiljkom s povratnicom  dostaviti privatnu ispravu vjerovniku (ovrhovoditelja); primjer se nalazi <a class="local-link" href="/contract?template=74">ovdje</a>.</p></li>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Povrat osnove za plaćanje radniku (dužniku) ili slanje osnove za plaćanje krivom adresatu/primatelju</strong></p>
    <p>Pojašnjenje: budući da se neke osnove za plaćanje izdaju samo u jednom primjerku (isprava po pristanku dužnika) i da postoji rizik od nepostupanja po ispravi zbog greške poslodavca (neodašiljanje isprave na vrijeme i sl.), postoji opasnost za poslodavca da će odgovarati za štetu vjerovniku ukoliko ispravu preda trećemu (radniku ili bilo kojoj drugoj osobi) ili ne postupi kako je zakonom određeno. Iz navedenih razloga, uvijek je potrebno postupiti na način određen Ovršnim zakonom te predati isprave novom poslodavcu ako mu je poznat ili vratiti vjerovniku preporučenom pošiljkom s povratnicom.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Ovršni zakon.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Naziv primatelja",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: false,
        placeholder: "Ostali podaci po potrebi",
      },
    ],
      suffix: "",
    }
  ],

    headline: "",
    title: '\r\n\r\nPREDMET: Obavijest o nemogućnosti postupanja po osnovi za plaćanje',
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
        {
            title: '',
            mandatory: false,
            dummy: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '- molim na ruke, ________________',
                    help: 'Po želji, slobodno upišite osobu kojoj želite dostaviti dopis.',
                    value: '',
                }],
        },
            
                {
                    title: '',
                    mandatory: true,
                    dummy: true,
                    exampleContent: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\nzaprimili smo zahtjev za zapljenom dijela primanja na temelju isprave iz čl. 202. Ovršnog zakona te uplatom na Vaš račun, a koju je izdao naš radnik ____________________, iz ____________________. \r\n\r\nOvim Vas putem obavještavamo da po navedenom zahtjevu kao poslodavac ne možemo postupiti iz razloga što provodimo pljenidbu i prijenos plaće na temelju ranije dostavljenih ovršnih isprava do najviše dopuštenih iznosa iz čl. 173 Ovršnog zakona. \r\nZaprimljenu ispravu ćemo zadržati u prednosnom redu, sve dok nam ne javite drugačije. \r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Ovrhovoditelju (vjerovniku) radnika \r\n2) Kadrovska služba',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/70_obavijest_nemogucnost.ts